const Personalspace = () => import("@/page/personalspace");
const privateFolder = () => import("@/page/personal/privateFolder");//私人文件
const fileedit = () => import("@/page/personal/fileDetailedit");//私人文件详情
const News = () => import("@/page/personal/news");//消息
const PersonalDetails = () => import("@/page/personal/personalDetails");//个人信息
const RecycleBin = () => import("@/page/personal/recycleBin");//回收站
const Audit = () => import("@/page/personal/audit");//未审核
const AuditDetails = () => import("@/page/personal/auditDetails");//审核详情
const PassAudit = () => import("@/page/personal/passaudit");//通过
const NopassAudit = () => import("@/page/personal/nopassaudit");//未通过
const ShedDetails = () => import("@/page/personal/shedDetail");//审核过详情
const setAuditor = () => import("@/page/personal/setauditor");//审核过详情

export default {
  path: "/Personalspace",  
  component: Personalspace,
  children:[ {
      path: 'privateFolder',
      name: 'privateFolder',
      component:privateFolder,
    },{
      path: 'fileedit',
      name: 'fileedit',
      component:fileedit,
    },{
      path: 'newsmain',
      name: 'newsmain',
      component:News,
    },{
      path: 'personalDetail',
      name: 'personalDetail',
      component:PersonalDetails,
    },{
      path: 'recycleBinmain',
      name: 'recycleBinmain',
      component:RecycleBin,
    },{
      path: 'audit',
      name: 'audit',
      component:Audit,
    },{
      path: 'nopassaudit',
      name: 'nopassaudit',
      component:NopassAudit,
    },{
      path: 'passaudit',
      name: 'passaudit',
      component:PassAudit,
    },{
      path: 'auditdetails',
      name: 'auditdetails',
      component:AuditDetails,
    },{
      path: 'sheddetails',
      name: 'sheddetails',
      component:ShedDetails,
    },{
      path: 'setauditor',
      name: 'setauditor',
      component:setAuditor,
    }]

};


// WEBPACK FOOTER //
// ./src/router/personal.js